module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/453.d0542daa.png";